<template>
    <el-dialog v-dialogDrag :title="$t('carPatrol.title.blackList')" :visible.sync="dialogTableBlackList" width="500px" :modal="false" :lock-scroll="true" :append-to-body="true" :before-close="handleCancelSelectionBlackList">
        <div class="select-bayonet el-border--around" v-loading="dataLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <div>
                <div class="inline-block bayonet-search relative">
                    <el-form :inline="true" :model="paramsBlackList" class="demo-form-inline" @submit.native.prevent>
                        <el-input :placeholder="$t('carPatrol.placeholder.blackGroup')" v-model="paramsBlackList.listName">
                            <i slot="prefix" class="el-input__icon el-icon-search search-group-name" @click="getNameListGroup" style="cursor:pointer;"></i>
                        </el-input>
                    </el-form>
                </div>
            </div>
            <!-- start @description: 黑名单表格组件 !-->
            <el-table
              ref="crud"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              height="300"
              stripe
              @selection-change="handleSelectBlackList">
              <el-table-column
                type="selection"
                width="55">
              </el-table-column>
              <el-table-column
                :label="$t('carPatrol.label.number')">
                <template slot-scope="scope">{{ scope.$index + 1 }}</template>
              </el-table-column>
              <el-table-column
                prop="name"
                :label="$t('carPatrol.label.blacklistName')">
              </el-table-column>
            </el-table>
        </div>
        <!-- 选定的人员名单 -->
        <div style="margin:10px 5px;">{{$t('carPatrol.title.selectGroup')}}</div>
        <div class="selected-bayonet el-border--around pd10">
            <el-tag closable v-for="tag in selectionBlackList" :key="tag.value" class="m5" @close="closeMulBlackList(tag)">
                {{tag.name}}
            </el-tag>
        </div>
        <div class="face-searc  h">
            <el-button size="small" type="primary" @click="handleFinalSelectionBlackList()">{{$t('carPatrol.button.confirm')}}</el-button>
            <el-button size="small" @click="handleCancelSelectionBlackList()">{{$t('carPatrol.button.cancel')}}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { api } from '../api'
import { setTimeout } from 'timers'

export default {
  components: {},
  data() {
    return {
      dataLoading: false,
      dialogTableBlackList: false,
      paramsBlackList: {
        listName: ''
      },
      selectionBlackList: [],
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: 10
      },
      //  表格任务的的配置项
      option: {
        height: 300,
        searchBtn: false,
        stripe: true,
        page: true,
        menu: false,
        editBtn: false,
        addBtn: false,
        refreshBtn: false,
        columnBtn: false,
        delBtn: false,
        header: false,
        // 行可勾选
        selection: true,
        index: true,
        indexLabel: '序号',
        column: [
          {
            label: '黑名单组名称',
            prop: 'name',
            align: 'center'
          }
        ]
      }
    }
  },
  watch: {
    dialogTableBlackList(newValue, oldValue) {
      setTimeout(() => {
        this.selectionBlackList.map((item, index) => {
          this.$refs['crud'].toggleRowSelection(item, true)
        })
      })
    }
  },
  mounted() {
    // this.getNameListGroup()
  },
  methods: {
    // 已经选择的人员名单组关闭标签数组自动减去1个
    closeMulBlackList(tag) {
      this.selectionBlackList.splice(this.selectionBlackList.indexOf(tag), 1)
      this.$refs['crud'].toggleRowSelection(tag, false)
    },
    // 确定按钮
    handleFinalSelectionBlackList() {
      if (!this.selectionBlackList.length) {
        this.$message.warning('选择布控名单组')
        return false
      }
      console.log('确定', this.selectionBlackList)
      this.dialogTableBlackList = false
      this.$emit('selectBlackList', this.selectionBlackList)
    },
    // 取消按钮
    handleCancelSelectionBlackList() {
      this.dialogTableBlackList = false
      this.paramsBlackList = {
        name: ''
      }
    },
    // 页面加载获取所有的车辆黑名单组
    // getNameListGroup(params) {
    //   const param = {
    //       name: this.paramsBlackList.listName
    //   }
    //   this.$fetch(api.task.queryVehicleGroup, param).then(response => {
    //     if (response.success) {
    //       this.tableData = response.returnObj.list
    //     } else {
    //       this.$message({
    //         message: response.msgContent,
    //         type: 'error'
    //       })
    //     }
    //   })
    // },
    getNameListGroup() {
      this.tableData = []
      let param = {
        name: this.paramsBlackList.listName
      }
      this.$fetch(api.task.queryVehicleGroup, param).then(res => {
        if (res.success) {
          this.selectionBlackList.length = 0
          this.tableData.length = 0
          this.tableData = res.returnObj.list
          this.$refs.crud.clearSelection()
          // 从父组件取出之前人员
          let carList = this.$parent.ruleForm.groupList
          let selectArr = []
          carList.forEach(i => {
            this.tableData.forEach(j => {
              if (i.repositoriesCode === j.code) {
                selectArr.push(j)
              }
            })
          })
          this.selectionBlackList = selectArr
          this.$refs['crud'].clearSelection()
          this.$nextTick(() => {
            this.selectionBlackList.forEach((item, index) => {
                this.$refs['crud'].toggleRowSelection(item)
            })
          })
        } else {
          this.$message({
            message: res.msgContent,
            type: 'error'
          })
        }
      })
    },
    // 单选人员组
    handleSelectBlackList(selection) {
      this.selectionBlackList = selection
    },
    // 全选人员组
    handleSelectAllBlackList(selection) {
      this.selectionBlackList = selection
    },
    // 回填数据
    // setData(data) {
    //   const param = {
    //     bwListGroupQryVo: {
    //       name: ''
    //     }
    //   }
    //   if (this.tableData.length === 0) {
    //     this.$fetch(api.task.queryVehicleGroup, param).then(response => {
    //       if (!response.success) {
    //         this.$message.error('失败')
    //         return
    //       }
    //       this.tableData = response.returnObj.list
    //       console.log(data)
    //       console.log()
    //       this.tableData.forEach(i => {
    //         data.forEach(j => {
    //           if (i.code === j.repositoriesCode) {
    //             this.selectionBlackList.push(i)
    //           }
    //         })
    //       })
    //     })
    //   }
    // }
  }
}
</script>
<style lang="scss" scoped>
.ioc-crud__table {
  padding: 0;
}
.bayonet-search {
  margin-bottom: 14px;
}
.selected-bayonet {
  background-color: rgb(43, 63, 100);
  height: 100px;
  overflow-y: scroll;
}
.face-search {
  text-align: center;
  margin-top: 26px;
}
.search-group-name {
  cursor: pointer;
}
</style>